export default __webpack_public_path__ + "static/media/wrong_target.a2f14c2f.svg";